import React from "react";
import SystemAdminDashboard from "views/systemadmin/dashboard";
import CenterManagement from "views/systemadmin/centers";
import TrialCenters from "views/systemadmin/trial-centers";
import UsersManagement from "views/admin/users-management";
import FaceCheckLogs from "views/systemadmin/face-check-logs";
import AuditLogs from "views/systemadmin/audit-logs";
import {
  MdOutlineAccessTime,
  MdOutlineBusiness,
  MdOutlineFace,
  MdOutlineGroups,
  MdOutlineHistory,
  MdOutlineSpaceDashboard,
} from "react-icons/md";

/** Routes dành cho SYSTEM_ADMIN (/systemadmin/*) */
const systemAdminRoutes = [
  {
    name: "nav.dashboard",
    layout: "/systemadmin",
    path: "dashboard",
    icon: <MdOutlineSpaceDashboard className="h-6 w-6" />,
    component: <SystemAdminDashboard />,
  },
  {
    name: "sysNav.centers",
    layout: "/systemadmin",
    path: "centers",
    icon: <MdOutlineBusiness className="h-6 w-6" />,
    component: <CenterManagement />,
  },
  {
    name: "trial.navTitle",
    layout: "/systemadmin",
    path: "trial-centers",
    icon: <MdOutlineAccessTime className="h-6 w-6" />,
    component: <TrialCenters />,
  },
  {
    name: "sysNav.usersManagement",
    layout: "/systemadmin",
    path: "users-management",
    icon: <MdOutlineGroups className="h-6 w-6" />,
    component: <UsersManagement />,
  },
  {
    name: "sysNav.faceCheckLogs",
    layout: "/systemadmin",
    path: "face-check-logs",
    icon: <MdOutlineFace className="h-6 w-6" />,
    component: <FaceCheckLogs />,
  },
  {
    name: "audit.navTitle",
    layout: "/systemadmin",
    path: "audit-logs",
    icon: <MdOutlineHistory className="h-6 w-6" />,
    component: <AuditLogs />,
  },
];

export default systemAdminRoutes;
